import { render, staticRenderFns } from "./APIRole.vue?vue&type=template&id=4dfc028e&"
import script from "./APIRole.vue?vue&type=script&lang=js&"
export * from "./APIRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports